/// 번역 메세지 사용하는 경우 - this.i18n_msg('code', obj)

// const _i18n_data = {
//   foo: {
//     EN : () => `foo message`,
//     KO : () => `내용.`,
//   },
//   bar: {
//     EN : ({id, no}) => `${id} is ${no}`,
//     KO : ({id, no}) => `${id} 는 ${no}`,
//   }
// };

export default {
  // computed: { i18n_data() { return _i18n_data; } }, // i18n 메세지 변환용.
  data: () => ({
    // ...
  }),
  methods: {
    // ...
  },
  created() { console.log('[vue] Modules.v1.Detail', 'created'); },
  destroyed() { console.log('[vue] Modules.v1.Detail', 'destroyed'); },
  mounted() { console.log('[vue] Modules.v1.Detail', 'mounted'); }
}
